<template>
  <div>
    <div class="personmsg" v-if="personmsg">
      <!-- 消息内容弹窗 -->
      <div class="pagePopMask pFull" @click.self="closePop"></div>
      <div class="pagePop pCenter">
        <div class="w pad60">
          <div class="tit fnt_24">{{ curid.title || globalDataArray.siteTemplateLanguage.message_title }}</div>

          <div class="cont">
            <div class="msgInfo">
              <p class="sender">{{ globalDataArray.siteTemplateLanguage.msg_publisher || '发送者' }}: {{ curid.sender }}</p>
              <p class="time">{{ globalDataArray.siteTemplateLanguage.publish_time || '发送时间' }}: {{ curid.createTime }}</p>
              <div class="line"></div>
              <div class="content-wrapper">
                <div class="markdown-content" v-html="parsedContent"></div>
              </div>
            </div>
          </div>

          <div class="btnBox fnt_18">
            <div class="btn btn1" @click="closePop">{{ globalDataArray.siteTemplateLanguage.verify || '确定' }}</div>
          </div>

          <div class="close" @click="closePop"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { marked } from 'marked'

// Configure marked options for better HTML rendering
marked.setOptions({
  breaks: true,
  gfm: true,
  headerIds: false,
  mangle: false
})

export default {
  name: 'Personmsg',
  props: {
    personmsg: {
      type: Boolean,
      default: false
    },
    curid: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {}
  },
  methods: {
    closePop() {
      this.$emit('update:personmsg', false)
    },
    parseMarkdown(content) {
      if (!content) return ''

      // 检查内容是否已包含HTML标签
      if (content.includes('<h') || content.includes('<p') || content.includes('<div')) {
        // 已经是HTML格式，直接返回
        return content
      }

      try {
        // 使用marked处理markdown内容
        return marked(content)
      } catch (e) {
        console.error('Content parsing error:', e)
        // 如果处理失败，至少确保换行符正确显示
        return content.replace(/\n/g, '<br>')
      }
    }
  },
  computed: {
    parsedContent() {
      return this.parseMarkdown(this.curid.msgContent || '')
    }
  }
}
</script>

<style lang="scss" scoped>
.personmsg {
  z-index: 999; // Ensure it's above other elements
}

.pagePopMask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 998;
}

.pagePop {
  position: fixed;
  z-index: 999;
  width: 700px;
  max-width: 90vw;
  background: #fff;
  border-radius: 10px;

  &.pCenter {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.w {
  position: relative;

  .tit {
    //text-align: center;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .cont {
    max-height: 60vh;
    overflow-y: auto;
    padding: 20px 0;
  }

  .msgInfo {
    .sender, .time {
      margin-bottom: 10px;
      color: #666;
    }

    .line {
      height: 1px;
      background-color: #e8e8e8;
      margin: 15px 0;
    }

    .content-wrapper {
      background-color: #f0f0f0;
      padding: 20px;
      border-radius: 5px;
      min-height: 100px;
      width: 100%;
      overflow-wrap: break-word;
      white-space: normal;
    }
  }

  .btnBox {
    text-align: center;
    margin-top: 20px;

    .btn {
      display: inline-block;
      padding: 4px 20px;
      border-radius: 5px;
      cursor: pointer;
      font-size: 14px;

      &.btn1 {
        background: #1890ff;
        color: white;
      }
    }
  }

  .close {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 20px;
    height: 20px;
    cursor: pointer;

    &:before, &:after {
      //content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      height: 2px;
      background: #999;
    }

    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }
  }
}

.pad60 {
  padding: 30px;
}

:deep(.markdown-content) {
  word-break: break-word;
  word-wrap: break-word;
  width: 100%;
  overflow: visible;

  h1, h2, h3, h4, h5, h6 {
    margin-top: 1em;
    margin-bottom: 0.5em;
    font-weight: bold;
  }

  h1 { font-size: 2em; }
  h2 { font-size: 1.5em; }
  h3 { font-size: 1.17em; }

  p { margin: 0.5em 0; }

  ul, ol {
    padding-left: 2em;
    margin: 0.5em 0;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  pre {
    background-color: #f5f5f5;
    padding: 0.5em;
    border-radius: 3px;
    overflow-x: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  code {
    background-color: #f5f5f5;
    padding: 0.2em 0.4em;
    border-radius: 3px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  blockquote {
    border-left: 3px solid #ddd;
    padding-left: 1em;
    color: #666;
    margin: 0.5em 0;
  }
}
</style>
